import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Attach bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jr_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Session expiry: redirect to login on 401 (except while on auth pages)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const path = window.location.pathname;
    if (err.response?.status === 401 && !["/login", "/reset-password"].includes(path)) {
      localStorage.removeItem("jr_token");
      window.location.href = "/login";
    }
    if (err.response?.status === 402 && path !== "/subscribe") {
      window.location.href = "/subscribe";
    }
    return Promise.reject(err);
  }
);

export default api;
